import { listConfig } from '@/api/ConfigApi'
import { listNav } from '@/api/NavApi'
const config = {
  state: {
    configs: [],
    menuList: []
  },
  getters: {
    project(state) {
      return state.configs.filter((conf) => conf.field === 'project_name')[0]
    },
    customer(state) {
      return state.configs.filter((conf) => conf.field === 'customer_name')[0]
    },
    projectIntro(state) {
      return state.configs.filter((conf) => conf.field === 'project_intro')[0]
    },
    navType(state) {
      return state.configs.filter((conf) => conf.field === 'nav')[0]
    },
    menuList(state) {
      return state.menuList
    },
    copyright(state) {
      return state.configs.filter((conf) => conf.field === 'copyright')[0]
    }
  },
  mutations: {
    SET_CONFIG(state, configs) {
      state.configs = configs
    },
    SET_NAV_MENU(state, menuList) {
      state.menuList = menuList
    }
  },
  actions: {
    FetchConfig(context) {
      listConfig().then((resp) => {
        if (resp.code === 0) {
          context.commit('SET_CONFIG', resp.data)

          // 请求菜单
          const nav = resp.data.filter((conf) => conf.field === 'nav')[0]
          listNav(nav.value).then((resp) => {
            context.commit('SET_NAV_MENU', resp.data)
          })
        }
      })
    }
  }
}
export default config
